import { CardHeader as MuiCardHeader, CardHeaderProps as MuiCardHeaderProps } from '@mui/material';

import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

type CardHeaderProps = MuiCardHeaderProps;

export const CardHeader = (props: CardHeaderProps) => {
  return <MuiCardHeader {...props} />;
};

export const PrimaryCardHeader = (props: CardHeaderProps) => {
  const { sx, slotProps, ...restProps } = props;

  return (
    <CardHeader
      sx={[
        { padding: 1, paddingLeft: 1.5 },
        ...toSxArray(sx),
        (theme) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText
        })
      ]}
      slotProps={{
        title: { variant: 'h3' },
        ...slotProps
      }}
      {...restProps}
    />
  );
};
